
import { useAdminAuth } from '@/hooks/useAdminAuth';

/**
 * Hook for managing authentication in the admin page
 * Enhanced with improved security features and better toast handling
 */
export const useAdminPageAuth = (
  recordAction: (actionType: string, adminName: string, details?: string) => void,
  removeActiveAdmin: (adminName: string) => Promise<any>,
  adminName: string
) => {
  const { handleLogout, verifyPassword } = useAdminAuth(
    recordAction,
    removeActiveAdmin,
    adminName
  );
  
  return {
    handleLogout,
    adminName,
    verifyPassword
  };
};
